import { get } from '../../index.js'
import base from '../../base.js'
export const getUserPerformanceList = (params) => get(base.userPerformanceList, params)
